// extracted by mini-css-extract-plugin
export default {"wrapper":"GameCard_wrapper__8bC60","delete_text":"GameCard_delete_text__f+gq3","name":"GameCard_name__YDplG"};